export default __webpack_public_path__ + "static/media/stock.d250876f.svg";